<template>
  <!-- Doc 34 (F2): kiosk screen routes render standalone — no session, no Entra
       gate (auth is the embed token in the URL, checked by the gateway). -->
  <RouterView v-if="isScreen" />
  <template v-else>
    <div
      v-if="auth.bootstrapping"
      class="flex h-full items-center justify-center text-sm text-gray-500"
    >
      {{ $t('projectRuntime.connecting') }}
    </div>
    <div v-else-if="auth.initializationFailed" class="grid h-full place-content-center gap-4 p-6 text-center"><p role="alert">{{ $t('projectRuntime.authUnavailable') }}</p><button class="text-brand-700 underline" @click="retryAuthentication">{{ $t('projects.reload') }}</button></div>
    <OperatorLogin v-else-if="auth.mode === 'operator' && !auth.isAuthenticated" />
    <Login v-else-if="auth.mode === 'oidc' && !auth.isAuthenticated" />
    <Signup v-else-if="auth.needsSignup" />
    <UpgradeWall v-else-if="auth.workspaceLocked" />
    <RouterView v-else />
  </template>
  <!-- App-wide dialog host (appAlert/appConfirm/appPrompt). -->
  <AppDialogHost />
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { RouterView } from 'vue-router';
import Login from './pages/Login.vue';
import OperatorLogin from './pages/OperatorLogin.vue';
import Signup from './pages/Signup.vue';
import UpgradeWall from './pages/UpgradeWall.vue';
import AppDialogHost from './components/AppDialogHost.vue';
import { useAuthStore } from './stores/auth';

const auth = useAuthStore();

// A screen/kiosk route must never trigger the Entra redirect (it would hijack
// the unattended display). Decide once from the entry URL.
const isScreen = window.location.pathname.startsWith('/screen/');
async function retryAuthentication(){await auth.initialize();if(!auth.initializationFailed && auth.mode==='oidc')await auth.bootstrap();if(auth.isAuthenticated)await auth.refreshWhoami();}

onMounted(async () => {
  if (isScreen) return; // no session bootstrap on kiosk screens
  await auth.initialize();
  // OIDC mode bootstrap: pick up redirect callback or restore session.
  // Permissive mode is a no-op (the store handles its own state).
  if (auth.mode === 'oidc' && !auth.initializationFailed) {
    await auth.bootstrap();
  }
  // Both modes: query /api/whoami so the sidebar can decide whether
  // to show the ops section AND detect the no-tenant signup state.
  if (auth.isAuthenticated) {
    await auth.refreshWhoami();
  }
});
</script>
